import { render, staticRenderFns } from "./VisualizarLotacaoDialog.vue?vue&type=template&id=007c5b3a"
import script from "./VisualizarLotacaoDialog.vue?vue&type=script&lang=js"
export * from "./VisualizarLotacaoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports